import { FC } from "react";
import { RsvpForm } from "./RsvpForm/RsvpForm";

export const Rsvp: FC = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2 col-xxl-6 offset-xxl-3">
          <div className="form-wrapper flowers neela-style">
            <h1 className="section-title">Will you Attend?</h1>
            <RsvpForm />
          </div>
        </div>
      </div>
    </div>
  );
};
